import React, { useEffect } from "react";

import { CustomerReviewsBlock } from "@reactivated";

import "./index.scss";

export const BazaarvoiceEmbed = ({
    value,
}: {
    value: CustomerReviewsBlock;
}) => {
    useEffect(() => {
        // Needs to be done this way to be compatible with strict-dynamic csp
        // this script should only be added once globally.
        const id = "bazaarvoice-loader";
        if (document.getElementById(id)) return;
        const el = document.createElement("script");
        el.async = true;
        el.src = `https://apps.bazaarvoice.com/deployments/${value.client_name}/${value.site_id}/${value.environment}/${value.locale}/bv.js`;
        el.id = id;
        document.head.appendChild(el);
    }, []);

    return (
        <div
            data-bv-show="reviews"
            data-bv-product-id="2025-relaunch-review-collection"
        />
    );
};
